<div
  class="list-option-container"
  [ngClass]="{ support: variant === 'ASSET_SUPPORT', selected: selected }"
>
  @if (variant === 'ASSET_SUPPORT') {
    <div class="d-flex">
      <pr-button
        [hidden]="selected"
        clazz="btn-support btn-support-add"
        display="neutral"
        size="xs"
        icon="add"
        iconWidth="24"
        (click)="onSelect.emit($event)"
      ></pr-button>
      <pr-button
        [hidden]="!selected"
        clazz="btn-support btn-support-remove"
        display="danger"
        variant="outline"
        size="xs"
        icon="sp-trash"
        iconWidth="24"
        iconViewBoxWidth="24"
        iconViewBoxHeight="24"
        (click)="onDeselect.emit($event)"
      ></pr-button>
    </div>
  }
  <div class="supports-container">
    @if (variant === 'ASSET_SUPPORT') {
      <div class="mrxs">
        <pr-icon
          [name]="labelIcon"
          [tooltip]="tooltipIcon || label"
          width="14"
          height="18"
        ></pr-icon>
      </div>
    }
    <div
      class="d-flex flex-column justify-content-space-between support-infos"
      [ngClass]="{ plm: !labelIcon && variant === 'ASSET_SUPPORT' }"
      [tooltip]="tooltip || (variant === 'ASSET_SUPPORT' ? label : '')"
      containerClass="tooltip-fix"
      placement="top"
      container="body"
    >
      <div class="d-flex justify-content-space-between">
        <div [ngClass]="{ 'd-flex flex-column': variant === 'ASSET_SUPPORT' }">
          @if (variant === 'DEFAULT') {
            <pr-icon [name]="labelIcon" [tooltip]="tooltipIcon || label"
              ><span class="text-ellipsis">{{ label }}</span></pr-icon
            >
          }
          @if (variant === 'ASSET_SUPPORT') {
            <span class="text-ellipsis">
              {{ label }}
            </span>
          }
          <pr-label
            [labelClass]="variant === 'ASSET_SUPPORT' ? 'sublabel' : ''"
            >{{ subLabel }}</pr-label
          >
        </div>
        <div
          class="d-flex flex-column align-items-flex-end justify-content-space-between"
        >
          @if (variant === 'DEFAULT') {
            <pr-button
              [hidden]="selected"
              label="Ajouter"
              display="neutral"
              size="lg"
              rightIcon="add"
              (click)="onSelect.emit($event)"
            >
            </pr-button>
          }
          @if (variant === 'DEFAULT') {
            <pr-button
              [hidden]="!selected"
              label="Supprimer"
              display="danger"
              variant="outline"
              size="lg"
              rightIcon="highlight_remove"
              (click)="onDeselect.emit($event)"
            >
            </pr-button>
          }
          @if (variant === 'ASSET_SUPPORT') {
            <pr-label
              labelDefaultClass="fs-12 fw-500"
              [labelClass]="'info-label ' + (infoClass ? infoClass : '')"
              >{{ infoLabel }}</pr-label
            >
          }
        </div>
      </div>
      <div
        class="d-flex justify-content-space-between"
        [ngClass]="{ mtm: variant === 'DEFAULT' }"
      >
        @if (criteriasLoading) {
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: #0066ff"
          ></i>
        }
        @if (!criteriasLoading) {
          @for (criteria of criterias; track criteria) {
            <span
              [ngClass]="{
                'text-success':
                  criteria.options?.color == 'success' &&
                  variant === 'ASSET_SUPPORT',
              }"
              >{{ criteria.label }} :
              <em
                [ngClass]="{
                  'text-success': criteria.options?.color == 'success',
                  'text-warning': criteria.options?.color == 'warning',
                  'text-danger': criteria.options?.color == 'danger',
                }"
                >{{ criteria.value }}</em
              ></span
            >
          }
        }

        @if (withMoreInfoAnchor) {
          <a class="pointer" (click)="onMoreInfoClick.emit($event)"
            >Plus d'infos</a
          >
        }
      </div>
    </div>
  </div>
</div>
